import { Component, Inject, TemplateRef, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface TemplateDialogData {
  title: string;
  templateVariable?: TemplateRef<unknown>;
  btnTemplateVariable?: TemplateRef<unknown>;
}

@Component({
  selector: "brd-template-dialog",
  templateUrl: "./template-dialog.component.html",
  styleUrl: "./template-dialog.component.less",
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TemplateDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TemplateDialogData
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
